export default __webpack_public_path__ + "static/media/FarmingExtensionGen2Template.e4ccb6e9.sol";